/* *****************************************
 * This is the form in charge of adding or
 * editing an address. To save an address
 * pass the 'formData' Obj containing
 * the values to save and if the
 * address is an 'edit' address
 * pass the 'isEdit' as the
 * second argument on the
 * 'onAdd' function
 * ***************
 *
 * @format */

import ModalPortal from 'frontier-admin/modal/container_portal';
import {CartCheckoutAddressForm, Form} from 'frontier/cart/components/addresses/form';
import React from 'react';

// styles
import './form_container.sass';

export function CartCheckoutAddressModal(props) {
    // decide what title to add
    const formType = props.formData.is_shipping_address === true ? 'Shipping' : 'Billing';
    const formStatus = props.formData.id ? 'Edit' : 'Save a New';
    const formTitle = `${formStatus} ${formType} Address`;

    return (
        <ModalPortal noCard>
            <CartCheckoutAddressForm
                handleClose={props.onClose}
                onSaveComplete={props.onSaveComplete}
                formData={props.formData || {}}
                formTitle={formTitle}
            />
        </ModalPortal>
    );
}
